export const backendDependencies = {
  'webservices.rest': '2.24.0',
  fhir2: '1.0.0-SNAPSHOT',
};
